<template>
	<div class="exclusivePrice-body">
		<div class="fx-header">
			<p>客户与私密商品关系</p>
		</div>
		<div class='container'>
			<div class="left-box">
				<div class="btn-box">
					<div class="btn" :class="isActive === 'isCus' ? 'active-btn' : ''" @click="typeChange('isCus')">客户类别</div>
					<div class="btn" :class="isActive === 'isGood' ? 'active-btn' : ''" @click="typeChange('isGood')">商品类别</div>
				</div>
				<div class="search-box">
					<el-input
						class="search-input"
						v-model="name"
						placeholder="请输入关键词"
						size="small"
						@keyup.enter.native="treeReload">
						<el-button slot="append" icon="el-icon-search" @click="treeReload"></el-button>
					</el-input>
				</div>
				<div class="tree-box" style="flex: 1;overflow:auto">
					<el-tree ref="tree" node-key="id" accordion :data="treeData" :default-expanded-keys="expandedKey" :highlight-current='true' class="tree" :props="defaultProps" @node-click="handleNodeClick">
					</el-tree>
				</div>
			</div>
			<div class="right-box">
				<tableBox ref="tableBox"></tableBox>
			</div>
		</div>
	</div>
</template>
<script>
import tableBox from '@/components/customerAndProduct/relationship.vue'
export default {
	name: 'customerAndProduct',
	components: {
		tableBox
	},
	data () {
		return {
			expandedKey: [],
			isActive: 'isCus',
			isChoose: false,
			name: '',
			treeData: [],
			defaultProps: {
				children: 'cus',
				label: 'name'
			},
			cusId: '',
			cusCategoryId: '',
			proId: '',
			bigTypeCategory: '',
			cusName: '',
			proName: '',
			smallTypeCategory: ''
		}
	},
	created () {
		this.treeReload()
	},
	methods: {
		handleNodeClick (data) {
			this.cusId = ''
			this.cusCategoryId = ''
			this.proId = ''
			this.isChoose = false
			this.cusName = ''
			this.proName = ''
			this.bigTypeCategory = ''
			this.smallTypeCategory = ''
			if (this.isActive === 'isCus') {
				if (data.id === '-1') {
					this.$nextTick(function () {
						this.$refs.tree.setCurrentKey('-1')
					})
				} else if (data.cus) {
					this.cusCategoryId = data.id
					this.tableBoxReload()
					this.$nextTick(function () {
						this.$refs.tree.setCurrentKey(data.id)
					})
				} else {
					this.cusId = data.id
					this.cusName = data.name
					this.isChoose = true
					this.tableBoxReload(true)
					this.$nextTick(function () {
						this.$refs.tree.setCurrentKey(data.id)
					})
				}
			} else {
				if (data.id === '-1') {
					this.$nextTick(function () {
						this.$refs.tree.setCurrentKey('-1')
					})
				} else {
					if (data.type === 0) {
						this.bigTypeCategory = data.id
						this.tableBoxReload()
						this.$nextTick(function () {
							this.$refs.tree.setCurrentKey(data.id)
						})
					}
					if (data.type === 1) {
						this.smallTypeCategory = data.id
						this.tableBoxReload()
						this.$nextTick(function () {
							this.$refs.tree.setCurrentKey(data.id)
						})
					}
					if (data.type === 2) {
						this.proId = data.id
						this.proName = data.name
						this.isChoose = true
						this.tableBoxReload(true)
						this.$nextTick(function () {
							this.$refs.tree.setCurrentKey(data.id)
						})
					}
				}
			}
		},
		tableBoxReload (flag) {
			let params = {
				cusId: this.cusId,
				cusCategoryId: this.cusCategoryId,
				keyword: this.name,
				cusName: this.cusName,
				proName: this.proName,
				isChoose: this.isChoose,
				proId: this.proId,
				bigTypeCategory: this.bigTypeCategory,
				smallTypeCategory: this.smallTypeCategory,
				isActive: this.isActive
			}
			this.$refs.tableBox.changeData(params, flag)
		},
		init (flag, id) {
			this.cusId = ''
			this.cusCategoryId = ''
			this.$nextTick(function () {
				this.$refs.tree.setCurrentKey('-1')
			})
			if (flag && id) {
				this.expandedKey = ['-1', id]
			} else {
				this.expandedKey = ['-1']
			}
			this.tableBoxReload()
		},
		treeReload () {
			let url = ''
			let data = {}
			if (this.isActive === 'isCus') {
				data = {
					name: this.name,
					type: 0
				}
				url = `${this.$fxBaseApi.urlQIV}/shop/customer/getCategoryORLevel4Price`
			} else {
				data = {
					keyword: this.name
				}
				url = `${this.$fxBaseApi.urlQIV}/shop/baseCategory/getShopCategoryProduct`
			}
			this.$store.dispatch('requestFilePost', {
				url: url,
				data: data
			}).then(res => {
				if (res.result) {
					if (res.data.length > 0) {
						let arr = [{
							name: '全部',
							id: '-1',
							cus: res.data
						}]
						this.treeData = arr
					} else {
						this.treeData = []
					}
					let flag = this.name !== ''
					let id = res.data[0] ? res.data[0].id : null
					this.init(flag, id)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		typeChange (data) {
			this.cusId = ''
			this.cusCategoryId = ''
			this.proId = ''
			this.isChoose = false
			this.cusName = ''
			this.proName = ''
			this.bigTypeCategory = ''
			this.smallTypeCategory = ''
			this.isActive = data
			this.treeReload()
		}
	}
}
</script>
<style lang="stylus" scoped>
.exclusivePrice-body{
	font-family: Microsoft YaHei;
	flex: 1
	display flex
	flex-direction column
	.container{
		display: flex;
		flex: 1;
		overflow: hidden;
		padding: 20px 0 10px 0
	}
	.left-box{
		width: 220px;
		height: 100%;
		display: flex;
		flex-direction: column
	}
	.btn-box{
		width: 210px;
		height: 34px;
		border-radius: 17px;
		background-color: #F4F6F8
		display: flex
	}
	.btn{
		width: 105px;
		height: 100%;
		border-radius: 17px;
		background-color: #F4F6F8;
		display: flex;
		align-items: center;
		color: #595959;
		justify-content: center;
		cursor: pointer;
	}
	.search-box{
		margin: 10px 0;
		border-radius: 4px;
	}
	.active-btn{
		background-color: var(--fx-primary-color);
		color: #ffffff
	}
	.right-box{
		flex: 1;
		display: flex;
		overflow: hidden;
		margin-left: 20px
	}
}
</style>
<style lang="stylus">
.exclusivePrice-body {
	.is-current> .el-tree-node__content{
		background-color: #EDF6FF;
		color: var(--fx-primary-color);
	}
	.el-tree {
		overflow: auto;
		>.el-tree-node {
            min-width: 100%;
			display: block !important;
			float: left;
        }
    }
    .dialog-footer{
		text-align: center
	}
	.dialog-title {
		text-align: left
		.el-dialog__title {
			padding-left 10px
			border-left 5px solid var(--fx-primary-color)
		}
        .name-input{
            width :150px
        }
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
